import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { PostMessage } from '../../../services/iframeService';
import { isMobile } from '../../../core/helpers/isMobile';
import { applicationStore } from '../../../store/applicationStore';
import LobbyIcon from '../../../components/common/lobbyIcon';

const LobbyIconWrapper = observer(() => {
  const lobbyIconContainerRef = useRef(null);
  const { iconsInfo } = applicationStore;

  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? window.innerWidth : 1440,
        y: isMobile() ? 104 : 134,
      },
    };
  }, []);

  const imgOptions = useMemo(() => iconsInfo?.find((item) => item.type === 'Lobby'), [iconsInfo]);

  useEffect(() => {
    if (imgOptions) {
      lobbyIconContainerRef.current.interactive = true;
      lobbyIconContainerRef.current.type = imgOptions.type;
      lobbyIconContainerRef.current.visible = true;
    }
  }, [iconsInfo, imgOptions, lobbyIconContainerRef]);

  const lobbyIconPostMessage = useCallback((e) => {
    if (e.target.type) {
      window.parent.postMessage({ name: PostMessage.OnOpenerIconClick, type: e.target.type }, '*');
    }
  }, []);

  if (!imgOptions) {
    return null;
  }

  return (
    <LobbyIcon
      image={imgOptions?.imageUrl}
      containerConfig={containerConfig}
      lobbyIconPostMessage={lobbyIconPostMessage}
      lobbyIconContainerRef={lobbyIconContainerRef}
    />
  );
});

export default LobbyIconWrapper;
